import React, { useState, useRef, useEffect } from 'react';
import UploadImage from '../../assets/image/imagePlaceholder.jpg';
import { Trash2 } from 'lucide-react';

const ImageUpload = ({ label, onImageUpload, error, disabled, imageUrl }) => {
	const [selectedImage, setSelectedImage] = useState(null);
	const inputRef = useRef();

	const handleImageChange = (event) => {
		const file = event.target.files[0];
		if (file) {
			setSelectedImage(URL.createObjectURL(file));
			onImageUpload(file);
		}
	};

	const handleClick = () => {
		inputRef.current.click();
	};

	const handleDelete = (event) => {
		event.stopPropagation();
		setSelectedImage(null);
		if (inputRef.current) {
			inputRef.current.value = '';
		}
		if (onImageUpload) {
			onImageUpload(null);
		}
	};

	const hasImage = Boolean(selectedImage || imageUrl);

	useEffect(() => {
		if (!imageUrl) {
			setSelectedImage(null);
		}
	}, [imageUrl]);

	return (
		<div className="image-upload-component">
			{label && <label className="form-label">{label}</label>}
			<div
				className="image-upload-wrapper"
				onClick={handleClick}
			>
				{hasImage ? (
					<>
						<img
							src={selectedImage !== null ? selectedImage : imageUrl}
							alt="Selected"
							className="image-preview"
						/>
						{!disabled && (
							<button
								type="button"
								className="delete-icon-btn"
								onClick={handleDelete}
								title="Delete image"
							>
								<Trash2 size={16} />
							</button>
						)}
					</>
				) : (
					<div className="image-placeholder">
						<img
							src={UploadImage}
							alt="Selected"
							className="placeholder"
						/>
						<span>Upload Image</span>
					</div>
				)}
			</div>
			<input
				type="file"
				ref={inputRef}
				style={{ display: 'none' }}
				accept="image/*"
				onChange={handleImageChange}
				disabled={disabled}
			/>
			{error && (
				<div
					className="error-text"
					style={{ color: 'red', fontSize: '12px', marginTop: '10px' }}
				>
					{error}
				</div>
			)}
		</div>
	);
};

export default ImageUpload;
